import React, { useState, useEffect, useRef } from "react";
import Select, {createFilter} from "react-select";
import { useTable } from "react-table";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import {
  getBankingSettlementAccountforEditApi,
  getBankingSettlementAccountInfoApi,
  getBankingSplitAccountInfoApi,
  TerminalMgmtApi,
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function Banking(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [isCutOverOffsetEditable, setIsCutOverOffsetEditable] = useState();
  const [isRoutingEditable, setIsRoutingEditable] = useState();
  const [isEditableTable, setIsEditableTable] = useState(false);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [terminalsData, setTerminalsData] = useState();
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [terminalData, setTerminalData] = useState();
  const [cutoverOffset, setCutOverOffset] = useState("");
  const [defaultSettlements, setDefaultSettlements] = useState();
  const [settlementOptions, setSettlementOptions] = useState([]);
  const [settlementValue, setSettlementValue] = useState();
  const [splitData, setSplitData] = useState([]);
  const location = useLocation();
  const history = useHistory();

  const EditableCell = (props) => {
    const [value, setValue] = useState({});
    const onChange = (e) => {
      console.log(e);
      setValue(e);
      props.updateCellData(props.row.id, props.column.id, e);
    };

    const onInputChange = (e) => {
      props.updateCellData(props.row.id, props.column.id, e.target.value);
    };
    return props.isInput ? (
      <input class="form-control"
        defaultValue={props.row.original.splitAmount}
        onBlur={onInputChange}
      />
    ) : (
      <Select
        options={props.options}
        defaultValue={props.defaultValue}
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        onChange={onChange}
        filterOption={createFilter({ ignoreAccents: false })}
        captureMenuScroll={false}
        classNamePrefix="custom-select"
        components={{ Option: CustomOption, MenuList: CustomMenuList }}
      />
    );
  };
  const updateCellData = (rowIndex, columnId, value) => {
    setSplitData((old) =>
      old.map((row, index) => {
        if (index == rowIndex) {
          console.log(row, "value is here");
          return {
            ...old[rowIndex],
            // [columnId]: value.label,
            ["edited"]: true,
            ...(columnId === "splitType" && { ["splitType"]: value.value }),
            ...(columnId === "destCode" && {
              ["destDescription"]: value.label,
            }),
            ...(columnId == "destCode" && { ["newDestCod"]: value.value }),
            ...(columnId == "splitAmount" && { ["splitAmount"]: value }),
          };
        }
        return row;
      })
    );
  };
  const columns = [
    {
      Header: "RTAHolderName",
      accessor: "destCode",
      Cell: (props) => {
        return props.row.original.destDescription;
      },
    },
    {
      Header: "RTA",
      accessor: "rta",
    },
    {
      Header: "HolderName",
      accessor: "holdername",
    },
    {
      Header: "SplitAmount",
      accessor: "splitAmount",
      Cell: (props) => {
        return (
          <h6>
            {/*{console.log(props, "1212121")}*/}
            {`${props.value} ${props.row.original.splitType == 0 ? "%" : ""}`}
          </h6>
        );
      },
    },
    {
      Header: "SplitType",
      accessor: "splitType",
      Cell: (props) => {
        return <h6>{props.value == 0 ? "percentage" : "fixed"}</h6>;
      },
    },
  ];
  const EditColumns = [
    {
      Header: "Account",
      accessor: "destCode",
      Cell: (props) =>
        EditableCell({
          ...props,
          updateCellData,
          options: settlementOptions,
          defaultValue: {
            label: `${props.row.original.destDescription}`,
            value: props.row.original.destCode,
          },
        }),
    },
    {
      Header: "Type",
      accessor: "splitType",
      Cell: (props) =>
        EditableCell({
          ...props,
          updateCellData,
          options: [
            { label: "%", value: "0" },
            { label: "fixed", value: "1" },
          ],
          defaultValue: {
            label: props.row.original.splitType == 0 ? "%" : "fixed",
            value: props.row.original.splitType,
          },
        }),
    },
    {
      Header: "Value",
      accessor: "splitAmount",
      Cell: (props) =>
        EditableCell({
          ...props,
          updateCellData,
          isInput: true,
        }),
    },
  ];

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      // onClick={() => console.log(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  useEffect(() => {

      const fetchTerminals =  () => {
          //let result = await axios.get(`${TerminalMgmtApi}?id=Administrator&searchCriteria=""&lastTxn=10&pageSize=500&currentPage=1&sortColumn=TerminalID&sortOrder=DESC`);
         console.log("--- GET List of Terminals........")
          setTerminalsData(props.terminalsData);
           props.terminalsData?.map((item, index) => {
           setTerminalSelectData((options) => [
             ...options,
             { label: item.terminalID, value: item.terminalID },
           ]);
         });
          const terminalId = location?.search?.split("=")?.[1];
          setSelectedTerminal({ label: terminalId, value: terminalId });
      };
      fetchTerminals();
  },[props, location]);




  useEffect(() => {

      const getBankingSettlementAccountInfo = async () => {
          const result = await axios.get(`${getBankingSettlementAccountInfoApi}?paramSourceType=1&paramSourceCode=${loggedUserStorage}&paramDestType=4&paramDestCode=8899&paramAssignCode=1&paramCurrentUserID=${loggedUserStorage}`);
          /*setDefaultSettlements({
              label: result?.data.response?.[0].destDescription,
              value: result?.data.response?.[0].destCode,
          });*/
          setDefaultSettlements(result?.data);
      };


    const getBankingSplitAccountInfo = async () => {
      const result = await axios.get(`${getBankingSplitAccountInfoApi}?paramSourceCode=${location?.search?.split("=")?.[1]}&paramUserID=${loggedUserStorage}`);
      const transformedData = result.data.response.map((e) => ({
        ...e,
        ["destDescription"]: e.holdername + "-" + e.rta,
        ["Type"]: "%",
        ["value"]: 100,
      }));
      setSplitData(transformedData);
    };
    /*const getSettlementOption = async () => {
      setSettlementOptions([]);
      let result = await axios.get(getBankingSettlementAccountforEditApi);
      console.log(result, "result");
      result?.data.response?.map((item, index) =>
        setSettlementOptions((option) => [
          ...option,
          { value: item?.destCode, label: item?.destDescription },
        ])
      );
    };*/
    getBankingSettlementAccountInfo();
    getBankingSplitAccountInfo();
    /**getSettlementOption();*/
    return () => {
      setTerminalSelectData([]);
    };
  }, [location]);
  const handleTerminalSelectClick = () => {
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${selectedTerminal.value}`,
    });

  };
  useEffect(() => {
    const terminalId = location?.search?.split("=")?.[1];
    const fetchTerminalById = async () => {
      setCutOverOffset("");
      let result = await axios.get(`getTerminalDetailsByID?termId=${terminalId}&searchCriteria=""&lastTxn=10`);
      setTerminalData(result?.data?.response?.[0]);
      setCutOverOffset(result?.data?.response?.[0]?.cutoverTimeVaultCash || "0");
    };

    fetchTerminalById();
    setSelectedTerminal({ label: terminalId, value: terminalId });

    return () => {
      setSelectedTerminal();
      setTerminalData();
      setCutOverOffset();
    };
  }, [location]);
  const hanldeRoutingEditable = async () => {
    setIsRoutingEditable(true);
        const result = await axios.get(`${getBankingSettlementAccountforEditApi}?paramSourceType=1&paramSourceCode=${loggedUserStorage}&paramDestType=4&paramDestCode=-1&paramAssignCode=1&paramCurrentUserID=${loggedUserStorage}`);
        /*result?.data.response?.map((item, index) =>
            setSettlementOptions((option) => [
                ...option,
                { value: item?.destCode, label: item?.destDescription },
            ])
        );*/
        setSettlementOptions(result?.data);

  };

    const handleSplitAccountEditable = async () => {
        setIsEditableTable(true);
        const result = await axios.get(`${getBankingSettlementAccountforEditApi}?paramSourceType=1&paramSourceCode=${loggedUserStorage}&paramDestType=4&paramDestCode=-1&paramAssignCode=1&paramCurrentUserID=${loggedUserStorage}`);
        /*result?.data.response?.map((item, index) =>
            setSettlementOptions((option) => [
                ...option,
                { value: item?.destCode, label: item?.destDescription },
            ])
        );*/

        setSettlementOptions(result?.data);
    };

  const handleSplitInfoSave = async () => {
    setIsEditableTable(false);
    const editedEntries = splitData.filter((item) => "edited" in item);
    console.log(editedEntries);
    if (editedEntries.length > 0) {
      try {
        const result = await Promise.all(
          editedEntries.map((entry) =>
            axios.get(`saveSurchargeAccount?paramTerminalID=${location?.search?.split("=")?.[1]}&paramAccountIDOld=${entry.destCode}&paramAccountIDNew=${entry.newDestCod || entry.destCode}&paramSplitType=${entry.splitType}&paramSplitAmount=${entry.splitAmount}`)
          )
        );
      } catch (error) {}
    }
  };
  const handleCutOverSave = async () => {
    setIsCutOverOffsetEditable(false);
    try {
      await axios.get(
        `savePayoutCutOverOffset?paramTerminalID=${
          location?.search?.split("=")?.[1]
        }&paramPayoutCutoverOffset=${cutoverOffset}`
      );
    } catch (error) {}
  };

  const handleRoutingSave = async () => {
    setIsRoutingEditable(false);
    try {
      await axios.get(
        `saveSettlementAccount?paramTerminalID=${
          location?.search?.split("=")?.[1]
        }&paramAccountID=${settlementValue.value}`
      );
    } catch (error) {}
  };
  return (
    <div className="mt-3">
      <div>
        <form>
          <div class="form-group form-inline">
            <label for="exampleInputEmail1">Terminal ID:</label>
            <div class="input-group ml-2">
              <Select
                options={terminalSelectData}
                value={selectedTerminal}
                onChange={(e) => setSelectedTerminal(e)}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "13vw",
                  }),
                }}
              />
              <span
                class="input-group-text"
                role="button"
                onClick={handleTerminalSelectClick}
              >
                Go
              </span>
            </div>
          </div>
        </form>
      </div>
      <div className="row d-flex flex-row align-items-center">
        <div className="col-xl-8">
          <h6 style={{ fontWeight: "bold" }}>
            Payout Cutover Offset(in Minutes)- Base time for ACH Cutover
            adjustment is:1501 (local switch time)
          </h6>
        </div>
        <div className="col-xl-4">
          <form>
            <div class="form-group form-inline">
              <div class="input-group">
                {console.log(cutoverOffset, "cut over")}
                <input
                  type="text"
                  class="form-control"
                  placeholder="cutoverVaultCash"
                  value={cutoverOffset}
                  onChange={(e) => setCutOverOffset(e.target.value)}
                  disabled={!isCutOverOffsetEditable}
                />
                {isCutOverOffsetEditable ? (
                  <>
                    <span
                      class="input-group-text"
                      role="button"
                      onClick={() => handleCutOverSave()}
                    >
                      Save
                    </span>
                    <span
                      class="input-group-text"
                      role="button"
                      onClick={() => setIsCutOverOffsetEditable(false)}
                    >
                      Cancel
                    </span>
                  </>
                ) : (
                  <span
                    class="input-group-text"
                    role="button"
                    onClick={() => setIsCutOverOffsetEditable(true)}
                  >
                    Edit
                  </span>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* table1 */}
      <div className="mt-3">
        <h6 style={{ fontWeight: "bold", textDecoration: "underline" }}>
          Default Settlement Account
        </h6>
        <div className="table-responsive">
          <table className="table table-bordered small">
            <thead className="thead-light">
              <th className="text-center">Routing/AccountNo</th>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">
                  <form>
                    <div class="form-group form-inline d-flex justify-content-center">
                      <div class="input-group">
                        <Select
                          isDisabled={!isRoutingEditable}
                          value={
                            !isRoutingEditable && !settlementValue
                              ? defaultSettlements
                              : settlementValue
                          }
                          options={settlementOptions}
                          onChange={setSettlementValue}
                          filterOption={createFilter({ ignoreAccents: false })}
                          captureMenuScroll={false}
                          classNamePrefix="custom-select"
                          components={{ Option: CustomOption, MenuList: CustomMenuList }}
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              flex: 1,
                              width: "400px",
                            }),
                          }}
                          menuPortalTarget={document.body}
                          menuPosition={"fixed"}
                        />
                        {isRoutingEditable ? (
                          <>
                            <span
                              class="input-group-text"
                              role="button"
                              onClick={() => handleRoutingSave()}
                            >
                              Save
                            </span>
                            <span
                              class="input-group-text"
                              role="button"
                              onClick={() => (
                                setIsRoutingEditable(false),
                                setSettlementValue(defaultSettlements)
                              )}
                            >
                              Cancel
                            </span>
                          </>
                        ) : (
                          <span
                            class="input-group-text"
                            role="button"
                            onClick={hanldeRoutingEditable}
                          >
                            Edit
                          </span>
                        )}
                      </div>
                    </div>
                  </form>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* table 2 */}
      <div>
        <h6 style={{ fontWeight: "bold", textDecoration: "underline" }}>
          Default Surcharge Split Account List
        </h6>
        <Table
          columns={isEditableTable ? EditColumns : columns}
          data={splitData}
        />
        <div className="d-flex flex-row justify-content-center mt-4">
          {!isEditableTable ? (
            <span
              className="input-group-text w-5"
              role="button"
              onClick={() => handleSplitAccountEditable()}
            >
              Edit
            </span>
          ) : (
            <>
              <span
                className="input-group-text w-5"
                role="button"
                onClick={() => handleSplitInfoSave()}
              >
                Save
              </span>
              <span
                className="input-group-text w-5 ml-2"
                role="button"
                onClick={() => setIsEditableTable(false)}
              >
                Cancel
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Banking;
